<template>
  <div class="floorManage">
    <div class="titleWrap">
      <div class="setTitle">楼层对应关系</div>
      <el-button class="myBtn" type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('delete') > -1" :disabled="delStatus" style="margin-left: 10px;" @click="remove">批量删除</el-button>
      <el-button class="myBtn" type="primary" size="small" v-if="villageId !== '' && funcData.indexOf('add') > -1" @click="add">新增</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-select class="select" v-model="villageValue" filterable size="small" placeholder="小区名称" v-if="villageId === ''" @change="search">
        <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="villageName" disabled size="small" placeholder="小区名称" v-else></el-input>
      <div class="clearfix"></div>
      <el-table :data="ruleAttr" class="list" @selection-change="selectRule">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="80" :index="indexRuleMethod" :align="align"></el-table-column>
        <el-table-column prop="orgName" label="小区名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="ruleName" label="显示规则名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="ruleText" label="规则内容" min-width="180" :align="align"></el-table-column>
        <el-table-column fixed="right" min-width="90" label="操作" v-if="villageId !== ''">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="villageId !== '' && funcData.indexOf('edit') > -1" @click="edit(scope.row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="ruleCurr" :page-sizes="[10, 20, 50]" :page-size="ruleSize" :total="ruleTotal" @current-change="ruleCurrChange" @size-change="ruleSizeChange"></el-pagination>
    </el-main>
    <!-- 新增编辑楼层对应关系弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px" size="small">
        <el-form-item label="小区名称" prop="village" v-if="villageId === ''">
          <el-select class="select" v-model="form.village" filterable clearable :disabled="form.villageStatus" size="small" placeholder="小区名称">
            <el-option v-for="item in form.villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区名称" :required="true" v-else>
          <el-input v-model.trim="villageName" disabled placeholder="小区名称"></el-input>
        </el-form-item>
        <el-form-item label="楼层显示规则名称" prop="ruleName" style="margin-bottom: 32px;">
          <el-input v-model.trim="form.ruleName" placeholder="楼层显示规则名称"></el-input>
        </el-form-item>
        <el-form-item class="contentItem" label="显示楼层" prop="ruleContent">
          <el-input v-model.trim="form.ruleContent" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="如：-3,-2,B1,g,-1,0,1,2:12,12A,12B,15:36"></el-input>
          <el-button class="showBtn" type="primary" size="mini" :disabled="!showBtnStatus" @click="show">显示</el-button>
        </el-form-item>
        <el-form-item label="楼层对应关系" style="margin-top: 32px;">
          <el-table class="floorList" :data="floorList" v-show="floorListFlag">
            <el-table-column type="index" label="序号" width="50" :align="align"></el-table-column>
            <el-table-column prop="floor" label="显示楼层" min-width="70" :align="align"></el-table-column>
            <el-table-column type="index" label="物理楼层" width="80" :index="indexMethod" :align="align"></el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FloorManage',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      delStatus: true, // 批量删除按钮的状态
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      ruleAttr: [], // 楼层规则列表
      ruleTotal: 0, // 楼层规则总数
      ruleSize: 10, // 楼层规则每页条数
      ruleCurr: 1, // 楼层规则当前页数
      dialog: false, // 楼层对应关系弹出层状态
      title: '', // 楼层对应关系弹出层标题
      loading: false, // 楼层对应关系弹出层确定按钮loading
      showBtnStatus: false, // 显示按钮状态
      form: {
        ruleId: '', // 规则Id
        village: '', // 小区名称
        villageList: [], // 小区名称下拉框
        villageStatus: false, // 小区名称下拉框状态
        ruleName: '', // 规则名称
        ruleContent: '' // 规则内容
      },
      selectRuleArr: [], // 选中的规则数组
      floorList: [], // 楼层对应关系列表
      floorListFlag: false, // 楼层对应关系列表状态
      rules: {
        village: [
          {
            required: true,
            message: '请选择小区名称',
            trigger: 'change'
          }
        ],
        ruleName: [
          {
            required: true,
            message: '请输入楼层显示规则名称',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('楼层显示规则名称由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        ruleContent: [
          {
            required: true,
            message: '请输入显示楼层',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z,:-]+$/
              if (!reg.test(value)) {
                this.showBtnStatus = false
                callback(new Error('显示楼层由英文字符、数字及“,”、“-”、“:”等符号组成'))
              } else {
                this.showBtnStatus = true
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName
    }

    // 获取小区名称下拉菜单
    this.$http.get(this.$api.village_list, {
      params: {
        pageSize: 9999,
        pageNum: 1
      }
    }).then((res) => {
      let data = res.data

      if (data.success) {
        this.villageValue = data.data.list[0].id
        this.villageList = data.data.list
        this.form.villageList = data.data.list

        // 获取楼层规则列表
        this.getRuleList(this.ruleCurr, this.ruleSize)
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  },
  methods: {
    getRuleList (page, size) {
      let params
      if (this.villageId === '') {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageValue
        }
      } else {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageId
        }
      }
      this.$http.get(this.$api.floor_rule_list, {
        params: params
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.ruleAttr = data.data.list
          this.ruleTotal = data.data.total
          this.ruleSize = size
          this.ruleCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getRuleList(1, this.ruleSize)
    },
    add () {
      this.dialog = true
      this.title = '新增楼层显示规则'
      this.form.villageStatus = false
    },
    edit (id) {
      this.$http.get(this.$api.floor_rule_detail, {
        params: {
          ruleId: id
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.form.ruleId = id
          this.form.village = data.data.data.orgId
          this.form.ruleName = data.data.data.ruleName
          this.form.ruleContent = data.data.data.ruleText
          this.dialog = true
          this.title = '编辑楼层显示规则'
          this.showBtnStatus = true
          this.form.villageStatus = true
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    selectRule (selection) {
      if (selection.length > 0) {
        this.delStatus = false
        this.selectRuleArr = []
        for (let i = 0; i < selection.length; i++) {
          this.selectRuleArr.push(selection[i].id)
        }
      } else {
        this.delStatus = true
      }
    },
    remove () {
      this.$confirm('是否删除楼层规则?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ruleIds = this.selectRuleArr.join()
        let formData = new FormData()
        formData.append('ruleIds', ruleIds)

        this.$http({
          method: 'post',
          url: this.$api.floor_rule_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            this.$message({
              message: '删除楼层规则成功',
              type: 'success',
              duration: 1000
            })
            this.getRuleList(1, this.ruleSize)
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
          this.loading = false
        }).catch((err) => {
          console.log(err)
          this.loading = false
        })
      }).catch(() => {})
    },
    notBtn () {
      this.loading = false
      this.form.ruleId = ''
      this.floorList = []
      this.floorListFlag = false
      this.$refs.form.resetFields()
      this.dialog = false
      this.form.village = ''
      this.form.ruleName = ''
      this.form.ruleContent = ''
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.form.ruleId === '') {
            let formData = new FormData()
            formData.append('ruleName', this.form.ruleName)
            formData.append('ruleText', this.form.ruleContent)
            if (this.villageId === '') {
              formData.append('orgId', this.form.village)
            } else {
              formData.append('orgId', this.villageId)
            }

            this.$http({
              method: 'post',
              url: this.$api.floor_rule_add,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.data.success) {
                this.$message({
                  message: '新增楼层规则成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getRuleList(this.ruleCurr, this.ruleSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.data.errMsg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          } else {
            let formData = new FormData()
            formData.append('ruleId', this.form.ruleId)
            formData.append('ruleName', this.form.ruleName)
            formData.append('ruleText', this.form.ruleContent)
            if (this.villageId === '') {
              formData.append('orgId', this.form.village)
            } else {
              formData.append('orgId', this.villageId)
            }

            this.$http({
              method: 'post',
              url: this.$api.floor_rule_edit,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.data.success) {
                this.$message({
                  message: '编辑楼层规则成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getRuleList(this.ruleCurr, this.ruleSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.data.errMsg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    },
    show () {
      if (this.form.ruleContent === '') {
        this.$message({
          type: 'error',
          message: '显示楼层为空',
          duration: 1000
        })
      } else {
        this.floorList = []
        this.floorListFlag = false

        this.$http.get(this.$api.floor_rule_check, {
          params: {
            ruleText: this.form.ruleContent
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.floorList.push({
                floor: data.data.data[i]
              })
            }
            this.floorListFlag = true
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    ruleCurrChange (curr) {
      this.getRuleList(curr, this.ruleSize)
    },
    ruleSizeChange (size) {
      this.getRuleList(this.ruleCurr, size)
    },
    indexMethod (index) {
      // index从0开始
      return index
    },
    indexRuleMethod (index) {
      // index从0开始
      return index + 1 + (this.ruleCurr - 1) * this.ruleSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.floorManage
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-left 20px
      width 160px
    .input
      float left
      margin-left 20px
      width 160px
    .searchBtn
      float left
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
      .el-button
          font-size 14px
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
        .contentItem
          position relative
          .showBtn
            position absolute
            top 0
            right -68px
        .floorList
          width 210px
          thead
            tr, th
              padding 4px 0
              color #666
              background-color #fafafa
              .cell
                  font-weight bold
          tbody
            tr, th
              color #333
          td
            padding 7px 0
          .cell
            line-height 26px
</style>



// WEBPACK FOOTER //
// src/components/village/floorManage.vue